<template>
  <cs-preloader-overlay :loading="loading">
    <div
      :class="[
        $style.container,
        {
          [$style.expire]: isExpiredStatus,
          [$style.success]: isSuccessStatus,
        }
      ]"
    >
      <payment-header
        :title="$t('crypto.payment.header.title', { currency: currency.code })"
        :language="getLanguage"
        has-redirect
        @redirect-back="$router.go(-1)"
      />
      <div
        :class="$style.content"
        v-z-index="100"
      >
        <crypto-payment-information
          v-m-b="30"
          :transaction="TRANSACTION"
          :loading="awating"
        />
        <empty-crypto-payment-list
          v-if="isEmptyList"
        />
        <crypto-payment-list
          v-else
          :transaction="TRANSACTION"
          :transactions-groups="transactions"
          :loading="awating"
        />

        <simple-button
          v-if="isExpiredStatus"
          v-m-t="30"
          v-position="'relative'"
          v-z-index="1000"
          variant="secondary"
          @click="handleRedirect"
        >
          {{ $t('crypto.payment.expire.submit') }}
        </simple-button>
      </div>
      <div :class="$style.footer">
        <base-footer />
      </div>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

import { formatDateToCustomDate } from 'lib/utils/date';

import HTTPService from '@/services/Http';

import ReconnectingWebSocket from 'services/socket/socket';
import processingSocketData from 'services/socket/process';

import BaseFooter from 'molecules/base/BaseFooter';
import SimpleButton from 'molecules/common/SimpleButton';
import PaymentHeader from 'organisms/payment/PaymentHeader';

import EmptyCryptoPaymentList from 'organisms/crypto/EmptyCryptoPaymentList';
import CryptoPaymentInformation from 'organisms/crypto/CryptoPaymentInformation';
import CryptoPaymentList from 'organisms/crypto/CryptoPaymentList';

import { CRYPTO_SOCKET_URL } from '@/.env';

const COUNT_REQUEST_INTERVAL = 10000;

export default {
  name: 'CryptoProcessing',
  components: {
    BaseFooter,
    SimpleButton,
    PaymentHeader,
    EmptyCryptoPaymentList,
    CryptoPaymentInformation,
    CryptoPaymentList,
  },
  data() {
    return {
      loading: false,
      awating: false,
      socket: null,
    };
  },
  created() {
    this.initializeData();
  },
  beforeDestroy() {
    this.socket.close();
  },
  computed: {
    paymentId() {
      const { query } = this.$route;

      if (!this.$validate.isObjectWithFields(query, ['paymentId'])) {
        return this.TRANSACTION.id;
      }

      if (this.$validate.isEmptyString(query.paymentId)) {
        return this.TRANSACTION.id;
      }

      return query.paymentId;
    },
    processToken() {
      const { query } = this.$route;

      if (!this.$validate.isObjectWithFields(query, ['processToken'])) {
        return this.TRANSACTION.processToken;
      }

      if (this.$validate.isEmptyString(query.processToken)) {
        return this.TRANSACTION.processToken;
      }

      return query.processToken;
    },
    currency() {
      return this.TRANSACTION.currency;
    },
    transactions() {
      const result = {};
      const { transactions } = this.TRANSACTION;
      // const transactions = [
      //   {
      //     amount: 119999,
      //     confirmation: 3,
      //     createdAt: '2022-08-08T09:50:32.55963',
      //     hash: 'f91848ccc29217f0909a2c64bec87e0ac7bb8b2a0d100c7a3cf453671f5abd89',
      //     target_confirmation: 3,
      //   },
      // ];

      console.log('list', transactions);

      if (this.$validate.isNull(transactions)) {
        return result;
      }

      transactions
        .forEach(transaction => {
          const key = formatDateToCustomDate(transaction.createdAt, 'DD.MM.YYYY');

          result[key] = result[key] || [];
          result[key].push(transaction);
        });

      return result;
    },
    isEmptyList() {
      return this.$validate.isEmptyObject(this.transactions);
    },
    isSuccessStatus() {
      return this.TRANSACTION.status === 'SUCCESS';
    },
    isExpiredStatus() {
      return this.TRANSACTION.status === 'EXPIRED';
    },
    ...mapState([
      'TRANSACTION',
    ]),
    ...mapGetters([
      'getLanguage',
      'isDigitalContent',
      'isPaymentAutoRedirection',
      'getSuccessUrl',
      'getFailUrl',
    ]),
  },
  methods: {
    connectionSocket() {
      this.socket = new ReconnectingWebSocket(`${CRYPTO_SOCKET_URL}?process_token=${this.processToken}`);

      this.socket.onopen = this.loadStatus;
      this.socket.onmessage = processingSocketData;
    },
    async initializeData() {
      console.log(this.paymentId, this.processToken);
      this.loading = true;

      try {
        this.connectionSocket();
        this.CLEAR_CRYPTO_TRANSACTION_LIST();

        await this.loadStatus();
        setInterval(this.loadStatus, COUNT_REQUEST_INTERVAL);
      } catch (error) {
        console.log(error);
        this.processingErrorResponse(error);
      } finally {
        this.loading = false;
      }
    },
    async loadStatus() {
      try {
        const { data } = await HTTPService.getCryptoPaymentStatus(this.paymentId, this.processToken);

        this.SET_TRANSACTION(data);
        this.SET_TRANSACTION_KEY(data.billCode || data.projectCode);

        this.awating = data.status === 'SUCCESS';
        this.processingPaymentResponse(data);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    // TODO: эта механика дублируется в EnterCard.vue надо подумать как избавиться
    processingPaymentResponse(data) {
      const { status } = data;
      console.log('PROCESSING_CRYPTO_PAYMENT::STATUS', status);

      if (this.$validate.isUndefined(status) || status === 'PROCESSING') {
        return;
      }

      this.redirectAfterPaymentByStatus(status);
    },
    // TODO: эта механика дублируется в EnterCard.vue надо подумать как избавиться
    processingErrorResponse(error) {
      if (!error.data) {
        this.$router.push({ name: 'service.error' });
        return;
      }

      console.log('PAYMENT_ERROR::DATA', error.data);
      const { status } = error.data;

      this.SET_TRANSACTION(error.data);
      this.SET_TRANSACTION_KEY(error.data.billCode || error.data.projectCode);

      if (this.$validate.isUndefined(status)) {
        this.$router.push({ name: 'service.error' });
        return;
      }

      this.redirectAfterPaymentByStatus(status);
    },
    // TODO: эта механика дублируется в PendingPayment.vue надо подумать как избавиться
    redirectAfterPaymentByStatus(status) {
      let pageName = '';

      if (status === 'SUCCESS') {
        if (this.isPaymentAutoRedirection) {
          window.location.assign(this.getSuccessUrl);
          return;
        }

        pageName = this.isDigitalContent ? 'PaidDigitalSelling' : 'paid.payment';
      }

      if (status === 'DECLINE' || status === 'FRAUD_DECLINE') {
        if (this.isPaymentAutoRedirection) {
          window.location.assign(this.getFailUrl);
          return;
        }

        pageName = 'rejected.payment';
      }

      if (status === 'FAIL') {
        if (this.isPaymentAutoRedirection) {
          window.location.assign(this.getFailUrl);
          return;
        }

        pageName = 'failed.payment';
      }

      console.log('redirect.after.payment.by.status', status, pageName);

      if (this.$validate.isEmptyString(pageName)) {
        return;
      }

      setTimeout(() => {
        this.$router.push({ name: pageName });
      }, 3000);
    },
    handleRedirect() {
      if (this.getFailUrl) {
        window.location.assign(this.getFailUrl);
        return;
      }

      window.location.assign(this.getProjectUrl);
    },
    ...mapMutations([
      'SET_TRANSACTION',
      'SET_TRANSACTION_KEY',
      'CLEAR_CRYPTO_TRANSACTION_LIST',
    ]),
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +flex-direction(column)
    min-height: 100vh
    position: relative

    &:before
      content: ''
      position: absolute
      width: 100%
      height: 100%
      top: 0
      right: 0
      background: url('@/assets/images/crypto-payment/cloud-1.svg') no-repeat center
      background-size: cover

    &:after
      content: ''
      position: absolute
      width: 100%
      height: 100%
      top: 0
      left: 0
      background: url('@/assets/images/crypto-payment/cloud-2.svg') no-repeat center
      background-size: cover

    &.expire

      &:after
        content: none

      & .content
        max-width: 380px

    &.success

      +respond-to('medium')
        &:before
          +size(470px, 386px)
          top: 400px
          background: url('@/assets/images/crypto-payment/stars-1.svg') no-repeat center

        &:after
          +size(470px, 386px)
          top: 400px
          background: url('@/assets/images/crypto-payment/stars-2.svg') no-repeat center

  .content
    +flex-grow
    width: 100%
    max-width: 500px
    margin: 0 auto
    padding: 30px 10px

  .footer
    margin-bottom: 20px
    padding: 0 10px
</style>
